module.exports = __webpack_public_path__ + "img/loader.942d1a58.svg";